import React from 'react';
import ReportingGiftCardsLiabilityPage from '../components/ReportingGiftCardsLiabilityPage';

const ReportingGiftCardsLiabilityApp = (props) => (
  <ReportingGiftCardsLiabilityPage {...props} />
);

export default ReportingGiftCardsLiabilityApp;
